module.exports = __webpack_public_path__ + "static/img/lt-app.524ee095.png";